export default class Purl {
  constructor(accounts) {
    if (!accounts) return null;



	let renewalAccount = accounts;

	const firstAccount = renewalAccount[0];

	const mapUniqAccount = () => {
		var seen = {};
	    var uniqAccount = [];
	    var accLen = renewalAccount.length;
		var j = 0;
		renewalAccount.map((account , i) =>{

			var key = account['package_type'] + account['section'] + account['row'] + account['seat_range'] + account['purl_template'];

			if(seen[key] !== 1) {
                  seen[key] = 1;
                  uniqAccount[j++] = account;
            }
		});

		return uniqAccount;
	};

	const numberFormatter = Intl.NumberFormat('en-US');
	// const formatted = numberFormatter.format(n);

    const mapAccounts = () => {
      return renewalAccount.map((account) => {
        return {
			id:
  		  	 typeof account["account_id"] === "string"
  			 ? Number.parseInt(account["account_id"])
  			 : account["account_id"],
			 account_type: account["purl_template"],
			 package_type: account["package_type"],
			 section: account["section"],
			 row: account["row"],
			 seat_range: account["seat_range"],
			 seat_quantity: account["seat_quantity"],
			 ticket_price : Number(account["ticket_price"]),
			 seat_price: Number(account["seat_price"]),
			 total_price_1: account["total_price"],
			 trait_list : account["trait_list"],

			 total_payment: account["total_payment"],
			 price_scale_code: account["price_scale_code"],
			 event_code: account["event_code"],
			 relocation_date: account["relocation_date"],
			 relocation_time: account["relocation_time"],

			 sth_2023_balance: account["sth_2023_balance"],
	 		 total_balance_due: account["total_balance_due"],
	 	  	 due_20_percentage: account["due_20_percentage"],
	 	  	 credit_payment: account["credit_payment"],
	 		 amusement_tax: account["amusement_tax"],
	 		 process_fee: account["process_fee"],
			 sth_2022_balance: account["sth_2022_balance"],




        };
      });
    };


    const mapRepInfo = () => {
      return {
	   name: firstAccount["rep_name"],
	   rep_last_name: firstAccount["rep_last_name"],
  	   email: firstAccount["rep_email"],
  	   phone: firstAccount["rep_phone"],
	   // title: firstAccount["rep_title"],
      };
    };

	const mapPriceScaleCode = () => {
      return {
		  package_type: firstAccount["package_type"],
   		  price_scale_code: firstAccount["price_scale_code"],
		  package_code: firstAccount["event_code"],
      };
    };

	const mapAddressInfo = () => {
      return {
	   address_1 : firstAccount["address_1"]  ? firstAccount["address_1"] : '',
  	   address_2 : firstAccount["address_2"]  ? firstAccount["address_2"] : '',
  	   city : firstAccount["city"]  ? firstAccount["city"] : '',
	   state: firstAccount["state"]  ? firstAccount["state"] : '',
	   zipcode : firstAccount["zipcode"]  ?  firstAccount["zipcode"] : '',
      };
    };

	const mapPaymentInfo = () => {
      return {
		sth_2023_balance: firstAccount["sth_2023_balance"],
		total_balance_due: firstAccount["total_balance_due"],
	  	due_20_percentage: firstAccount["due_20_percentage"],
	  	credit_payment: firstAccount["credit_payment"],
		amusement_tax: firstAccount["amusement_tax"],
		process_fee: firstAccount["process_fee"],

      };
    };

	this.accountId =
	 typeof firstAccount["account_id"] === "string"
	   ? Number.parseInt(firstAccount["account_id"])
	   : firstAccount["account_id"];

    this.accounts = mapAccounts();
    this.rep = mapRepInfo();
	this.paymentInfo = mapPaymentInfo();
	this.uniqAc = mapUniqAccount();
	this.getPriceScaleCode = mapPriceScaleCode();
	this.total2022Balance = firstAccount["sth_2022_balance"];
	this.total2023Balance = firstAccount["total_balance_due"];
	this.total_discount = (parseFloat(firstAccount["sth_2022_balance"].replace(/[$,]/g,'')) - parseFloat(firstAccount["total_balance_due"].replace(/[$,]/g,''))).toLocaleString('en-US');
	this.addressInfo =  mapAddressInfo();
	this.account_type= (firstAccount["purl_template"] != "STH") && (firstAccount["purl_template"] != "SUITE") ? "premier" : firstAccount["purl_template"].toLowerCase();
	this.fullName = firstAccount["first_name"] + " " + firstAccount["last_name"];
	this.firstName = firstAccount["first_name"] ? firstAccount["first_name"] : firstAccount["last_name"];
	this.lastName = firstAccount["last_name"];
	this.phone =  firstAccount["phone_number"] ? firstAccount["phone_number"].toLowerCase() : '';
	this.email_address =  firstAccount["email"] ? firstAccount["email"].toLowerCase() : '';
	this.sth_2023_balance = firstAccount["sth_2023_balance"];
	this.total_balance_due = firstAccount["total_balance_due"];
	this.due_20_percentage = firstAccount["due_20_percentage"];
	this.credit_payment = firstAccount["credit_payment"].replace("-", "");
	this.amusement_tax = firstAccount["amusement_tax"];
	this.process_fee = firstAccount["process_fee"];
	this.package_type = firstAccount["package_type"];
	this.purl_template = firstAccount["purl_template"];
	// this.submitted = firstAccount["submitted"];

  }
}
